import stylex from '@stylexjs/stylex';
export const appLayoutStyles = stylex.create({
    host: {},
});
